const update = ({ data, loadingState, oldData, draft }) => {
  const result = { ...oldData, loading: false };

  // Update in items if present
  if (Array.isArray(oldData?.items)) {
    const findIndex = oldData.items.findIndex(
      (item: any) => String(item?.id) === String(data?.id),
    );
    if (findIndex > -1) {
      result.items = [...oldData.items];
      result.items[findIndex] = { ...oldData.items[findIndex], ...data };
    }
  }

  // Update in data if present
  if (Array.isArray(oldData?.data)) {
    const findIndex = oldData.data.findIndex(
      (item: any) => String(item?.id) === String(data?.id),
    );
    if (findIndex > -1) {
      result.data = [...oldData.data];
      result.data[findIndex] = { ...oldData.data[findIndex], ...data };
    }
  } else if (
    !!oldData?.data &&
    typeof oldData.data === "object" &&
    String(oldData.data.id) === String(data?.id)
  ) {
    result.data = { ...oldData.data, ...data };
  }

  return result;
};

export default update;
